// removed by extract-text-webpack-plugin
module.exports = {"cart":"CartComponent__cart___1v8gS","cartIndicator":"CartComponent__cartIndicator___10WSP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Cart/CartComponent.scss
 ** module id = 772
 ** module chunks = 0
 **/